import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Box, Card, CardContent, Typography } from "@mui/material";

type KpiTileProps = {
  label: string;
  value: string | number | undefined | null;
  delta?: number | null;
  deltaSuffix?: string;
  invertDelta?: boolean;
};

const KpiTile = ({ label, value, delta, deltaSuffix = "", invertDelta = false }: KpiTileProps) => {
  const hasDelta = delta !== undefined && delta !== null;
  const positive = (delta ?? 0) > 0;
  const neutral = (delta ?? 0) === 0;
  const good = invertDelta ? !positive : positive;
  let color = "text.secondary";
  if (!neutral) {
    color = good ? "success.main" : "error.main";
  }
  const sign = positive ? "+" : "";

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        borderRadius: 2,
        borderColor: "divider",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        transition: "box-shadow .2s ease, transform .2s ease",
        "&:hover": { boxShadow: "0 6px 16px rgba(0,0,0,0.10)", transform: "translateY(-2px)" },
      }}
    >
      <CardContent sx={{ py: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}
        >
          {label}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, my: 0.5, lineHeight: 1.1 }}>
          {value ?? "—"}
        </Typography>
        {hasDelta && (
          <Box sx={{ display: "flex", alignItems: "center", color, minHeight: 24 }}>
            {!neutral && (positive ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />)}
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {sign}
              {delta}
              {deltaSuffix}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default KpiTile;
